import { isValid, parseISO } from "date-fns";

export const isValidDate = (dateString?: string) => {
  if (!dateString) return false;
  return isValid(parseISO(dateString));
};
